import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import logo from '../../assets/drush.svg'
import { Container, Logo, Main, RightSide, MenuButton, MenuOptions, VerticalMenu, Buttons } from './styles'
import Search from '../SearchBar'
import GiftButton from '../Buttons/Gift'
import BellButton from '../Buttons/Bell'
import UserButton from '../Buttons/User'
import MenuIcon from '@material-ui/icons/Menu'

function Navbar() {
  const menuRef = useRef()
  const [showMenu, setShowMenu] = useState(false)
  const [opacity, setOpacity] = useState(0)

  useEffect(() => {
    window.addEventListener('mousedown', handleClick)
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('mousedown', handleClick)
      window.removeEventListener('scroll', handleScroll)
    }
  })

  function handleScroll() {
    if ((opacity === 0) && (window.scrollY > 10)) {
      setOpacity(1)
    } else if ((opacity === 1) && (window.scrollY < 10)) {
      setOpacity(0)
    }
  }

  function handleClick(event) {
    if (showMenu && !menuRef.current.contains(event.target)) {
      setShowMenu(false)
    }
  }

  function drawMenuOptions() {
    return (
      <>
      </>
    )
  }

  return (
    <Container opacity={opacity}>
      <Main>
        <Logo
          to='/'
          title='DramRush'
        >
          <img
            alt='dramarush-logo'
            src={logo}
          />
        </Logo>
        <VerticalMenu>
          {drawMenuOptions()}
        </VerticalMenu>
      </Main>
      <RightSide>
        <Search />
      </RightSide>
    </Container>
  )
}

export default Navbar
